import React from "react";
import AsyncSelect from "react-select/async";
import { useLazyGetProductsQuery } from "../../masters/products/productsApi";

const toOption = (p) => ({
  value: p.productCode,
  label: `${p.productName} (${p.productCode})${p.unit ? " - " + p.unit : ""}`,
  product: p,
});

// Products are branch-local (Product_Code collides across branches, same as
// custId), so this always searches within one branch - mirrors
// EmployeePicker.jsx's AsyncSelect shape.
const ProductPicker = ({ branchId, value, onChange, disabled }) => {
  const [triggerSearch] = useLazyGetProductsQuery();

  const loadOptions = async (inputValue) => {
    if (!branchId || !inputValue || inputValue.trim().length === 0) return [];
    const { data = [] } = await triggerSearch({ branchId, search: inputValue.trim() });
    return data.map(toOption);
  };

  return (
    <AsyncSelect
      classNamePrefix="react-select"
      cacheOptions
      loadOptions={loadOptions}
      value={value}
      onChange={onChange}
      isDisabled={disabled || !branchId}
      placeholder={branchId ? "Search product by name or code" : "Select a branch first"}
      noOptionsMessage={({ inputValue }) =>
        inputValue ? "No matching products" : "Type to search products"
      }
    />
  );
};

export default ProductPicker;
